import { render, staticRenderFns } from "./SpecialOfferEdit.vue?vue&type=template&id=37fab790&scoped=true&"
import script from "./SpecialOfferEdit.vue?vue&type=script&lang=ts&"
export * from "./SpecialOfferEdit.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialOfferEdit.vue?vue&type=style&index=0&id=37fab790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fab790",
  null
  
)

export default component.exports